(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ebsi-navigation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ebsi-navigation')) {
    customElements.define('ebsi-navigation', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const { signal } = this.abort;
        this.surface = this.querySelector('.ebsi-nav-surface');
        this.toggle = this.querySelector('.ebsi-mobile-toggle');
        this.closeButton = this.querySelector('.ebsi-mobile-close');
        this.mobile = matchMedia('(max-width: 1099px)');
        this.hover = matchMedia('(hover: hover) and (pointer: fine)');
        this.contexts = [...this.querySelectorAll('[data-context]')];
        this.eligible = this.dataset.eligible.split('|').filter(Boolean);
        this.selected = this.dataset.selected;
        if (this.dataset.pageType === 'product' || this.dataset.pageType === 'collection') {
          try {
            const stored = sessionStorage.getItem('ebsi-academy');
            if (this.eligible.includes(stored)) this.selected = stored;
          } catch {}
        }
        this.setContext(this.selected);
        this.toggle.addEventListener('click', () => this.openDrawer(), { signal });
        this.closeButton.addEventListener('click', () => this.closeDrawer(), { signal });
        this.mobile.addEventListener('change', () => this.closeDrawer(false), { signal });
        this.querySelectorAll('details').forEach(details => {
          const summary = details.querySelector(':scope > summary');
          summary.setAttribute('aria-expanded', String(details.open));
          details.addEventListener('toggle', () => {
            summary.setAttribute('aria-expanded', String(details.open));
            if (details.open && details.classList.contains('ebsi-top-details')) {
              this.closeOthers(details);
            }
          }, { signal });
          if (!details.classList.contains('ebsi-top-details')) return;
          details.addEventListener('pointerenter', event => {
            if (event.pointerType !== 'mouse' || !this.hover.matches || this.mobile.matches) return;
            clearTimeout(details.leaveTimer);
            details.enterTimer = setTimeout(() => { this.closeOthers(details); details.open = true; }, 125);
          }, { signal });
          details.addEventListener('pointerleave', event => {
            clearTimeout(details.enterTimer);
            if (event.pointerType !== 'mouse' || this.mobile.matches || details.contains(document.activeElement)) return;
            const r = details.querySelector('.ebsi-panel').getBoundingClientRect();
            const origin = {x:event.clientX,y:event.clientY};
            const corridor = [origin,{x:r.left-12,y:r.top+20},{x:r.right+12,y:r.top+20}];
            const deadline = performance.now() + 650;
            clearTimeout(details.leaveTimer);
            const track = move => {
              const p={x:move.clientX,y:move.clientY};
              const cross=(a,b,c)=>(a.x-c.x)*(b.y-c.y)-(b.x-c.x)*(a.y-c.y);
              const d=[cross(p,corridor[0],corridor[1]),cross(p,corridor[1],corridor[2]),cross(p,corridor[2],corridor[0])];
              const triangle=!(d.some(x=>x<0)&&d.some(x=>x>0));
              const inside=p.x>=r.left&&p.x<=r.right&&p.y>=r.top&&p.y<=r.bottom;
              if (inside) { clearTimeout(details.leaveTimer); document.removeEventListener('pointermove',track); return; }
              if (triangle && performance.now()<deadline) {
                clearTimeout(details.leaveTimer);
                details.leaveTimer=setTimeout(finish,125);
              } else finish();
            };
            const finish=()=>{
              document.removeEventListener('pointermove',track);
              if (!details.matches(':hover') && !details.contains(document.activeElement)) details.open=false;
            };
            details.leaveTimer=setTimeout(finish,125);
            document.addEventListener('pointermove',track,{signal});
          }, { signal });
          details.addEventListener('focusout', event => {
            if (details.contains(event.relatedTarget)) return;
            clearTimeout(details.focusTimer);
            details.focusTimer=setTimeout(() => {
              if (!this.mobile.matches && !details.contains(document.activeElement)) details.open=false;
            },125);
          }, { signal });
        });
        this.addEventListener('click', event => {
          const anchor=event.target.closest('a');
          if (!anchor) return;
          if (anchor.hasAttribute('data-global-link')) {
            try { sessionStorage.removeItem('ebsi-academy'); } catch {}
          } else {
            const key=anchor.dataset.academyLink || this.selected;
            if (key) try { sessionStorage.setItem('ebsi-academy',key); } catch {}
          }
        }, { signal });
        document.addEventListener('click', event => {
          if (this.surface.hasAttribute('data-open') && !this.surface.contains(event.target) && !this.toggle.contains(event.target)) this.closeDrawer();
          else if (!this.contains(event.target)) this.closeOthers();
        }, { signal });
        document.addEventListener('keydown', event => this.handleKey(event), { signal });
        this.observer=new ResizeObserver(()=>{
          const height=this.getBoundingClientRect().height;
          document.body.style.setProperty('--header-height',height+'px');
          document.body.style.setProperty('--header-group-height',height+'px');
        });
        this.observer.observe(this);
        if (location.hash === '#academies' && !this.selected) {
          if (this.mobile.matches) this.openDrawer();
          const academyMenu=this.querySelector('[data-context="global"] .ebsi-top-item:nth-child(2) details');
          if (academyMenu) academyMenu.open=true;
        }
      }
      setContext(key) {
        this.selected=key;
        this.contexts.forEach(context=>{context.hidden=context.dataset.context!==(key||'global');});
        if (key) try { sessionStorage.setItem('ebsi-academy',key); } catch {}
      }
      closeOthers(except) {
        this.querySelectorAll('.ebsi-top-details[open]').forEach(details=>{
          if (details!==except) {clearTimeout(details.enterTimer);clearTimeout(details.leaveTimer);details.open=false;}
        });
      }
      openDrawer() {
        if (this.surface.hasAttribute('data-open')) return;
        this.surface.setAttribute('data-open','');
        this.surface.setAttribute('role','dialog');
        this.surface.setAttribute('aria-modal','true');
        this.surface.setAttribute('aria-label',this.querySelector('.ebsi-mobile-heading > span').textContent);
        this.toggle.setAttribute('aria-expanded','true');
        this.oldOverflow=document.body.style.overflow;
        document.body.style.overflow='hidden';
        this.inerted=[];
        let current=this.surface;
        while(current.parentElement && current.parentElement!==document.documentElement) {
          [...current.parentElement.children].forEach(sibling=>{
            if(sibling!==current && !sibling.inert && !['SCRIPT','STYLE','LINK'].includes(sibling.tagName)) {sibling.inert=true;this.inerted.push(sibling);}
          });
          current=current.parentElement;
        }
        this.closeButton.focus();
      }
      closeDrawer(restore=true) {
        if (!this.surface.hasAttribute('data-open')) return;
        this.surface.removeAttribute('data-open');
        this.surface.removeAttribute('role');
        this.surface.removeAttribute('aria-modal');
        this.surface.removeAttribute('aria-label');
        this.toggle.setAttribute('aria-expanded','false');
        document.body.style.overflow=this.oldOverflow || '';
        this.inerted?.forEach(element=>{element.inert=false;});
        if(restore) this.toggle.focus();
      }
      handleKey(event) {
        if (event.key==='Escape') {
          const focused=document.activeElement;
          const branch=focused?.closest('.ebsi-branch[open]');
          const top=focused?.closest('.ebsi-top-details[open]');
          const open=branch || top;
          if(open) {event.preventDefault();open.open=false;open.querySelector(':scope > summary').focus();}
          else if(this.surface.hasAttribute('data-open')) {event.preventDefault();this.closeDrawer();}
          else this.closeOthers();
        }
        if(event.key==='Tab' && this.surface.hasAttribute('data-open')) {
          const focusable=[...this.surface.querySelectorAll('a,button,summary,[tabindex="0"]')].filter(el=>{
            if (!el.getClientRects().length || el.closest('[hidden]') || el.disabled) return false;
            let ancestor=el.parentElement;
            while (ancestor && ancestor!==this.surface) {
              if (ancestor.tagName==='DETAILS' && !ancestor.open && el!==ancestor.querySelector(':scope > summary')) return false;
              ancestor=ancestor.parentElement;
            }
            return true;
          });
          const first=focusable[0],last=focusable.at(-1);
          if(event.shiftKey && document.activeElement===first) {event.preventDefault();last.focus();}
          else if(!event.shiftKey && document.activeElement===last) {event.preventDefault();first.focus();}
        }
      }
      disconnectedCallback() {
        this.closeDrawer(false);
        this.abort?.abort();
        this.observer?.disconnect();
        this.querySelectorAll('details').forEach(details=>{clearTimeout(details.enterTimer);clearTimeout(details.leaveTimer);clearTimeout(details.focusTimer);});
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
